import styled from 'styled-components'

import { Button } from 'aem-libs-react-components/src/components/forms/button'
import { MEDIA_QUERY } from 'aem-libs-react-components/src/styles'

export const BgCard = styled.div`
  background: ${({ theme }) => theme.colors.common.regular.aubergine};
  color: ${({ theme }) => theme.colors.font.white};
  border-radius: 0.75rem;
  max-width: 1200px;
  margin: auto;
  padding: 35px;
  @media ${MEDIA_QUERY.MOBILE} {
    margin: 0 15px;
    padding: 30px;
  }
`

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  @media ${MEDIA_QUERY.MOBILE} {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`

export const CardContent = styled.div`
  padding: 20px 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const FieldsWrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
  width: 320px;
  margin: 0 auto;
  @media ${MEDIA_QUERY.MOBILE} {
    width: 100%;
  }
`

export const SubmitButton = styled(Button)`
  width: min-content;
  margin: auto;
`
